import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "week-text-row flex between-xs" }

import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'WeekText',
  props: {
    firstDayOfWeek: {
      type: Number,
      default: 0,
    },
  },
  setup(__props) {

const props = __props

  const { tm } = useI18n();

  

  const weekdays = computed(() => {
    let days = [];
    for (let i = 0; i < 7; i++) {
      days.push(tm(`searchForm.calendar.dayAbbr`)[i]);
    }
    return [
      ...days.slice(props.firstDayOfWeek),
      ...days.slice(0, props.firstDayOfWeek),
    ];
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(weekdays), (day, i) => {
      return (_openBlock(), _createElementBlock("span", {
        class: "week-text",
        key: i
      }, _toDisplayString(day), 1))
    }), 128))
  ]))
}
}

})